import { useCartMutationVariables } from "@/core/api/graphql/cart/composables";
import { useMutation } from "@/core/api/graphql/composables";
import { SetWantsInvoicePdfDocument } from "@/core/api/graphql/types";
import type { CartIdFragment, CartExtension } from "@/core/api/graphql/types";
import type { MaybeRef } from "vue";

export function useSetWantsInvoicePdfMutation(cart?: MaybeRef<CartIdFragment | undefined>) {
  return useMutation(SetWantsInvoicePdfDocument, useCartMutationVariables(cart));
}

/** @deprecated Use {@link useSetWantsInvoicePdfMutation} instead. */
export async function setWantsInvoicePdf(wantsInvoicePdfTL: boolean): Promise<CartExtension> {
  const { mutate } = useSetWantsInvoicePdfMutation();
  const result = await mutate({ command: { wantsInvoicePdfTL } });
  return result!.data!.setWantsInvoicePdf as CartExtension;
}
